<script setup lang="ts">
import { ref } from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import type { MenuItem } from 'primevue/menuitem';

const props = defineProps<{
  selectedCount: number;
  showCloseAction: boolean;
}>();

const emit = defineEmits<{
  close: [];
  delete: [];
  clear: [];
}>();

const menuRef = ref<InstanceType<typeof Menu> | null>(null);

const menuItems = ref<MenuItem[]>([]);

function openMenu(event: Event) {
  const items: MenuItem[] = [];
  if (props.showCloseAction) {
    items.push({
      label: 'Closed',
      icon: 'pi pi-check-circle',
      command: () => emit('close'),
    });
  }
  items.push({
    label: 'Delete',
    icon: 'pi pi-trash',
    class: 'text-red-600',
    command: () => emit('delete'),
  });
  menuItems.value = items;
  menuRef.value?.toggle(event);
}
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2"
  >
    <span class="text-sm font-medium text-gray-800">
      {{ selectedCount }} selected
    </span>
    <Button
      label="Bulk Actions"
      icon="pi pi-chevron-down"
      iconPos="right"
      size="small"
      severity="secondary"
      @click="openMenu"
    />
    <Menu ref="menuRef" :model="menuItems" popup />
    <button
      type="button"
      class="text-sm font-medium text-gray-600 hover:text-gray-900"
      @click="emit('clear')"
    >
      Clear
    </button>
  </div>
</template>
